import { render, staticRenderFns } from "./TerrainBadge.vue?vue&type=template&id=46e32c9a&scoped=true"
import script from "./TerrainBadge.vue?vue&type=script&lang=js"
export * from "./TerrainBadge.vue?vue&type=script&lang=js"
import style0 from "./TerrainBadge.vue?vue&type=style&index=0&id=46e32c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e32c9a",
  null
  
)

export default component.exports